import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/<lang>/stays` used to be a second stays landing page competing with the
 * real hub at `/<lang>/category/stays` — same word, same intent, only one of
 * them in the sitemap. The landing page is gone; this route survives purely
 * so the URL keeps resolving for anything already pointing at it (old links,
 * bookmarks, anything Google picked up before the consolidation).
 *
 * 301, not the default 307: a temporary redirect leaves Google indexing both
 * URLs and splitting the signal between them, which is the exact duplication
 * this removes. Same rule as $slug.index.tsx.
 *
 * The booking funnel is untouched — /<lang>/stays/<city> and
 * /<lang>/stays/<city>/<slug> are their own file routes and never reach here.
 */
export const Route = createFileRoute("/$lang/_layout/stays/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/category/$category",
      params: { lang: params.lang, category: "stays" },
      replace: true,
      statusCode: 301,
    });
  },
});
